module.exports = __webpack_public_path__ + "static/media/transfersArrow.c00268df.svg";